import { createMutationGroup } from "../../core/api/mutations";
import {
  ICD10CodeId,
  PatientId,
  PatientMedicationId,
  PatientMedicalDiagnosisCodeId,
} from "../../shared/schema/schema";

export default createMutationGroup(({ api, createMutation }) => ({
  createMedication: (patientId: PatientId) =>
    createMutation({
      mutationFn: (body: {
        name: string;
        dosage: string;
        frequency: string | null;
        administrationNotes: string | null;
      }) =>
        api.post("./patients/:patientId/medications", {
          path: { patientId },
          body: body,
        }),
    }),
  removeMedication: (patientId: PatientId) =>
    createMutation({
      mutationFn: (medicationId: PatientMedicationId) =>
        api.delete("./patients/:patientId/medications/:medicationId", {
          path: { patientId, medicationId },
        }),
    }),
  updateNotTakingMedications: (patientId: PatientId) =>
    createMutation({
      mutationFn: (body: { notTakingMedications: boolean }) =>
        api.put("./patients/:patientId/not_taking_medications", {
          path: { patientId },
          body,
        }),
    }),
  updateMedication: (patientId: PatientId) =>
    createMutation({
      mutationFn: (params: {
        medicationId: PatientMedicationId;
        body: {
          name: string;
          dosage: string;
          frequency: string | null;
          administrationNotes: string | null;
        };
      }) =>
        api.put("./patients/:patientId/medications/:medicationId", {
          path: { patientId, medicationId: params.medicationId },
          body: params.body,
        }),
    }),
  createMedicalDiagnosisCode: () =>
    createMutation({
      mutationFn: (body: {
        patientId: PatientId;
        icdCode: ICD10CodeId;
        designation: "PRIMARY" | "OTHER";
        source: string | null;
      }) => api.post("./patient_medical_diagnosis_codes", { body }),
    }),
  updateMedicalDiagnosisCode: (patientMedicalDiagnosisCodeId: PatientMedicalDiagnosisCodeId) =>
    createMutation({
      mutationFn: (body: {
        designation?: "PRIMARY" | "OTHER";
        icdCode?: ICD10CodeId;
        source?: string | null;
      }) =>
        api.put("./patient_medical_diagnosis_codes/:patientMedicalDiagnosisCodeId", {
          path: { patientMedicalDiagnosisCodeId },
          body,
        }),
    }),
  deleteMedicalDiagnosisCode: (patientMedicalDiagnosisCodeId: PatientMedicalDiagnosisCodeId) =>
    createMutation({
      mutationFn: () =>
        api.delete("./patient_medical_diagnosis_codes/:patientMedicalDiagnosisCodeId", {
          path: { patientMedicalDiagnosisCodeId },
        }),
    }),
}));
